module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Preface-rw",
    attrs: {
      "epub:type": "frontmatter preface",
      "id": "preface1"
    }
  }, [_c('h1', {
    staticClass: "preface-title"
  }, [_c('span', {
    attrs: {
      "href": "#/toc#toc-preface002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HERE COMES A")]), _vm._v(" moment in the life of every individual when reality must be faced. When this happens, it is as though a link between emotion and reason is stretched to the limit of endurance, and sometimes snaps. In this collection of stories, men, women, children and a nation are brought to the breaking point. Whether the link survives or snaps, the reader must judge for himself.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f777049","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface002.vue
// module id = 66
// module chunks = 0